import PurchaseMethodsActions from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActions.js';
import PurchaseMethodsActionsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import DataConversions from 'commons-vehicle/PurchaseMethods/constants/dataConversions.js';
import PaymentFrequencies from 'commons-vehicle/PurchaseMethods/constants/paymentFrequencies.js';
import PurchaseMethodsConstant from 'commons-vehicle/PurchaseMethods/constants/purchaseMethods.js';
import PurchaseMethodsValues from 'commons-vehicle/PurchaseMethods/constants/purchaseMethodsValues.js';
import en from 'commons-vehicle/PurchaseMethods/i18n/en.json';
import fr from 'commons-vehicle/PurchaseMethods/i18n/fr.json';
import CashPurchaseModel from 'commons-vehicle/PurchaseMethods/models/CashPurchaseModel.js';
import FinanceModel from 'commons-vehicle/PurchaseMethods/models/FinanceModel.js';
import PaymentFrequencyModel from 'commons-vehicle/PurchaseMethods/models/PaymentFrequencyModel.js';
import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import TermModel from 'commons-vehicle/PurchaseMethods/models/TermModel.js';
import PurchaseMethodsReducer from 'commons-vehicle/PurchaseMethods/reducers/purchaseMethodsReducer.js';

import CashPurchaseService from 'commons-vehicle/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js';
import FinanceService from 'commons-vehicle/PurchaseMethods/services/FinanceService/FinanceService.js';
import PaymentFrequencyService from 'commons-vehicle/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js';
import PurchaseMethodsService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js';
import TermService from 'commons-vehicle/PurchaseMethods/services/TermService/TermService.js';

import DisclaimerAPIService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js';

const Translations = {
    en,
    fr,
};

export {
    PurchaseMethodsActions,
    PurchaseMethodsActionsTypes,
    DataConversions,
    PaymentFrequencies,
    PurchaseMethodsConstant,
    PurchaseMethodsValues,
    Translations,
    CashPurchaseModel,
    FinanceModel,
    PaymentFrequencyModel,
    PurchaseMethodsModel,
    TermModel,
    PurchaseMethodsReducer,
    CashPurchaseService,
    FinanceService,
    PaymentFrequencyService,
    PurchaseMethodsService,
    TermService,
    DisclaimerAPIService,
};

export default {
    PurchaseMethodsActions,
    PurchaseMethodsActionsTypes,
    DataConversions,
    PaymentFrequencies,
    PurchaseMethodsConstant,
    PurchaseMethodsValues,

    Translations,

    CashPurchaseModel,
    FinanceModel,
    PaymentFrequencyModel,
    PurchaseMethodsModel,
    TermModel,
    PurchaseMethodsReducer,

    CashPurchaseService,
    FinanceService,
    PaymentFrequencyService,
    PurchaseMethodsService,
    TermService,
    DisclaimerAPIService,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/PurchaseMethods/index.js